<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">Editar Fornecedor</p>
    </div>

    <q-form @submit.prevent="editarFornecedor" ref="myForm" class="q-mt-sm">
      <div class="row col-12 q-col-gutter-sm">
        <div
          class="col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Nome do Fornecedor
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="fornecedor.nome"
          />
        </div>

        <div
          class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Nome Fantasia
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="fornecedor.fantasia"
          />
        </div>

        <div
          class="col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          CNPJ
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="fornecedor.cnpj"
          />
        </div>

        <div class="col-lg-1 col-md-2 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            label="Salvar"
            no-caps
            style="background-color: #21324a; border-radius: 8px; color: white"
            icon="done"
            @click="editarFornecedor()"
          />
        </div>
      </div>
    </q-form>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  name: "EditarFerramenta",

  setup() {
    const $q = useQuasar();
    const $route = useRoute();
    const id = $route.params.id;
    const router = useRouter();
    const myForm = ref(null);
    const store = useStore();

    const fornecedor = ref({
      id: "",
      nome: "",
      fantasia: "",
      cnpj: "",
    });

    let consultarFornecedor = async () => {
      let resposta = await store.dispatch("org/consultarFornecedor", {
        id: id,
      });
      fornecedor.value = resposta.fornecedor;
    };

    let editarFornecedor = async () => {
      await store.dispatch("org/editarFornecedor", {
        id: fornecedor.value.id,
        nome: fornecedor.value.nome,
        fantasia: fornecedor.value.fantasia,
        cnpj: fornecedor.value.cnpj,
      });

      $q.notify({
        message: "Dados Alterados!",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });

      router.push({ name: "org-fornecedor" });
    };

    onMounted(() => {
      consultarFornecedor();
    });

    return {
      fornecedor,
      myForm,
      consultarFornecedor,
      editarFornecedor,
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
